<form class="mx-[12px]" [formGroup]="newPasswordForm" (ngSubmit)="submitForm()">
  <p class="mt-[32px] font-inter font-bold text-base xlplus:text-lg">
    Reset Password
  </p>
  <div class="flex flex-col gap-[16px] mt-[16px]">
    <label class="font-lato font-bold text-sm xlplus:text-base">
      New Password
    </label>
    <p-password
      formControlName="inputNewPassword"
      [feedback]="false"
      [toggleMask]="true"
      inputStyleClass="!w-full"
      styleClass="!w-full"
      [autocomplete]="autocompleteEnabled() ? 'new-password' : 'off'"
      [class.ng-dirty]="
        newPasswordForm.hasError('passwordMismatch') &&
        (newPasswordForm.touched || newPasswordForm.dirty)
      "
      [class.ng-invalid]="
        newPasswordForm.hasError('passwordMismatch') &&
        (newPasswordForm.touched || newPasswordForm.dirty)
      "
    />

    <div class="space-y-2">
      @for (rule of passwordRules(); track $index) {
      <div class="flex flex-row gap-2 items-center">
        <svg
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-[13px] xlplus:w-[16px] h-[14px] xlplus:h-[17px]"
          [ngClass]="
            inputNewPassword?.dirty &&
            inputNewPassword?.value?.trim() &&
            !inputNewPassword?.hasError(rule.rule)
              ? 'text-[#1A8B57]'
              : 'text-[#83858A]'
          "
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 1.5C5.61553 1.5 4.26216 1.91054 3.11102 2.67971C1.95988 3.44888 1.06267 4.54213 0.532856 5.82122C0.00304288 7.1003 -0.135594 8.50776 0.134503 9.86563C0.404599 11.2235 1.07128 12.4708 2.05025 13.4497C3.02922 14.4287 4.27649 15.0954 5.63436 15.3655C6.99223 15.6356 8.3997 15.497 9.67878 14.9672C10.9579 14.4373 12.0511 13.5401 12.8203 12.389C13.5895 11.2378 14 9.88447 14 8.5C13.9979 6.64412 13.2598 4.86486 11.9475 3.55255C10.6352 2.24025 8.85588 1.50208 7 1.5ZM7 13.75C5.96165 13.75 4.9466 13.4421 4.08324 12.8652C3.21989 12.2883 2.547 11.4684 2.14964 10.5091C1.75228 9.54977 1.64831 8.49417 1.85088 7.47577C2.05346 6.45737 2.55346 5.52191 3.28769 4.78769C4.02191 4.05346 4.95738 3.55345 5.97578 3.35088C6.99418 3.1483 8.04979 3.25227 9.0091 3.64963C9.96841 4.04699 10.7883 4.7199 11.3652 5.58326C11.9421 6.44661 12.25 7.46165 12.25 8.5C12.25 9.89238 11.6969 11.2277 10.7123 12.2123C9.72775 13.1969 8.39239 13.75 7 13.75ZM9.00637 6.13137L6.125 9.01275L4.99363 7.88137C4.91291 7.7978 4.81637 7.73114 4.70961 7.68528C4.60286 7.63943 4.48803 7.61529 4.37185 7.61428C4.25567 7.61327 4.14044 7.63541 4.03291 7.67941C3.92538 7.7234 3.82769 7.78837 3.74553 7.87053C3.66338 7.95268 3.59839 8.05038 3.55439 8.15791C3.5104 8.26545 3.48828 8.38067 3.48929 8.49685C3.4903 8.61303 3.51444 8.72785 3.5603 8.8346C3.60615 8.94136 3.6728 9.03791 3.75637 9.11862L5.50637 10.8686C5.67046 11.0327 5.89298 11.1248 6.125 11.1248C6.35702 11.1248 6.57954 11.0327 6.74363 10.8686L10.2436 7.36862C10.3272 7.28791 10.3938 7.19136 10.4397 7.0846C10.4856 6.97785 10.5097 6.86303 10.5107 6.74685C10.5117 6.63067 10.4896 6.51545 10.4456 6.40791C10.4016 6.30038 10.3366 6.20268 10.2545 6.12053C10.1723 6.03837 10.0746 5.9734 9.96709 5.92941C9.85956 5.88541 9.74433 5.86327 9.62815 5.86428C9.51197 5.86529 9.39714 5.88943 9.29039 5.93528C9.18363 5.98114 9.08709 6.0478 9.00637 6.13137Z"
            fill="currentColor"
          />
        </svg>
        <p
          class="text-xs xlplus:text-sm"
          [ngClass]="
            inputNewPassword?.dirty &&
            inputNewPassword?.value?.trim() &&
            !inputNewPassword?.hasError(rule.rule)
              ? 'text-[#1A8B57]'
              : 'text-taxpod-gray-light'
          "
        >
          {{ rule.text }}
        </p>
      </div>
      }
    </div>

    <label class="font-lato font-bold text-sm xlplus:text-base">
      Confirm Password
    </label>
    <p-password
      formControlName="inputConfirmPassword"
      [feedback]="false"
      [toggleMask]="true"
      inputStyleClass="!w-full"
      styleClass="!w-full"
      [autocomplete]="autocompleteEnabled() ? 'new-password' : 'off'"
      [class.ng-dirty]="
        newPasswordForm.hasError('passwordMismatch') &&
        (newPasswordForm.touched || newPasswordForm.dirty)
      "
      [class.ng-invalid]="
        newPasswordForm.hasError('passwordMismatch') &&
        (newPasswordForm.touched || newPasswordForm.dirty)
      "
    />
  </div>
  @if (newPasswordForm.hasError('passwordMismatch') && (newPasswordForm.touched ||
  newPasswordForm.dirty )) {
  <div class="mt-2 xlplus:mt-2">
    <p class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]">
      The Confirm Password does not match the New Password
    </p>
  </div>
  }
  <!--
    There is deliberately NO "all fields are required" line here. Emptiness is
    communicated by the submit button staying disabled (see `isButtonDisabled`),
    per the P.O. decision of 2026-09-15 — the message used to render the instant
    a recipient opened their reset link, before they had typed anything.
    `reset-password.component.spec.ts` fails if it comes back.
  -->
  <div class="mt-[24px]">
    <p-button
      type="submit"
      [loading]="isSubmitting"
      [disabled]="isButtonDisabled()"
      styleClass="!w-full !bg-taxpod-blue !border-taxpod-blue disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
      ><p class="font-lato font-bold text-sm xlplus:text-base">
        Reset Password
      </p></p-button
    >
  </div>
</form>

<p
  class="flex justify-center items-center gap-2 mt-[28px] mx-[12px] mb-[12px] font-lato font-bold text-center text-sm xlplus:text-base cursor-pointer text-taxpod-blue"
  routerLink="/auth/login"
>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.04754 13.0623L7.35387 13.774C7.06015 14.0753 6.5852 14.0753 6.29461 13.774L0.220288 7.545C-0.0734293 7.24365 -0.0734293 6.75636 0.220288 6.45821L6.29461 0.226013C6.58833 -0.0753378 7.06327 -0.0753378 7.35387 0.226013L8.04754 0.937715C8.34438 1.24227 8.33813 1.73918 8.03504 2.03733L4.26984 5.71766H13.2501C13.6657 5.71766 14 6.06068 14 6.48706V7.51294C14 7.93932 13.6657 8.28235 13.2501 8.28235H4.26984L8.03504 11.9627C8.34126 12.2608 8.34751 12.7577 8.04754 13.0623Z"
      fill="#00B0ED"
    />
  </svg>
  Back to Login
</p>
